const zh = {
  nav: {
    home: "首页", about: "关于我们", services: "服务",
    faqs: "常见问题", contact: "联系", consultation: "预约咨询",
  },
  brand: {
    firmName: "全弘民律师事务所",
    motto: "为外国出生的个人及小企业主提供法律服务!!",
    photoSoon: "照片即将发布",
    attorneyTitle: "律师",
    attorneyName: "全弘民",
    yearsLabel: "印第安纳州经验", yearsValue: "22年以上",
    languagesLabel: "语言", focusLabel: "专业领域", focusValue: "遗嘱 & 信托",
  },
  hero: {
    h1Line1: "遗嘱、信托与",
    h1Line2: "婚前协议律师",
    desc1: "作为移民处理遗产规划和家庭法律事务面临独特挑战 — 跨境资产、文化传统、语言障碍以及对签证状态的担忧。我们了解这些，因为我们曾经服务过和您一样的家庭。",
    desc2: "我们以多种语言提供遗嘱起草、信托成立和婚前协议服务，对移民经历有着深刻的理解。",
    cta1: "预约咨询", cta2: "查看服务",
    note: "遗嘱、信托与婚前协议 · 专为移民家庭提供法律服务",
  },
  aboutAtty: {
    sectionCalligraphy: "我们的故事",
    storyTitle1: "我们也是移民 —",
    storyTitle2: "我们理解您的旅程",
    storyP1: "这家律师事务所是为移民社区而建立的 — 那些努力工作、跨越国界建立生活，现在希望确保他们所创造的一切得到保护并以正确方式传承的家庭。",
    storyP2: "许多移民面临差距：标准的遗产规划律师不总能理解跨文化家庭结构、海外资产或以第二语言应对法律系统的焦虑的复杂性。我们弥合这一差距。",
    storyP3: "我们说您的语言 — 字面和比喻意义上。我们的事务所专注于遗嘱起草、信托成立和婚前协议，每份文件都基于对您独特背景和您想留下的遗产的理解而创建。",
    learnMore: "了解更多关于事务所的信息",
    attyCalligraphy: "认识您的律师",
    quote: "\"我帮助移民家庭和个人创建遗嘱、信托和婚前协议，反映他们跨越国界、文化和世代的独特生活。我的目标很简单：保护您所建立的一切，确保它以清晰、安全和平静的心情传承下去。\"",
    fullProfile: "查看完整简历",
    commitments: [
      { icon: "ri-translate-2", label: "多语言服务", note: "English · 한국어 · 中文" },
      { icon: "ri-global-line", label: "跨境专业知识", note: "跨越多个国家的资产和家庭关系" },
      { icon: "ri-heart-3-line", label: "文化敏感性", note: "尊重多元化的家庭结构和传统" },
      { icon: "ri-shield-check-line", label: "移民意识规划", note: "了解移民身份如何影响遗产决策" },
    ],
  },
  servicesPreview: {
    calligraphy: "专业领域",
    title1: "三项专注服务，",
    title2: "围绕您的故事",
    consultationCta: "预约咨询",
    viewDetails: "点击查看详情",
    services: [
      {
        number: "01", title: "遗嘱起草", calligraphy: "最终遗嘱与遗言",
        intro: "精心起草的遗嘱是任何遗产计划的基础。对于移民家庭，它更具分量 — 两个国家的资产、跨越大洲的大家庭、超越国界的监护权问题。我们全面处理。",
        details: [
          { title: "为移民家庭定制的简单和复杂遗嘱", body: "根据印第安纳州法典 § 29-1-5-3，有效遗嘱要求立遗嘱人年满18周岁、具有法律行为能力，并需两名证人在场签名。对于移民家庭而言，满足这些法律要求只是起点——我们还要处理您情况的全部复杂性：跨两个司法管辖区的资产、具有文化意义的个人财产，以及横跨多国的家庭结构。无论您是持有美国经纪账户同时在韩国拥有不动产，还是商业权益与预期海外继承并存，我们确保您遗产的每一层都被明确记录、依法处理。任何资产都不被假定，任何家庭成员都不被忽视。" },
          { title: "针对在本国持有资产的条款", body: "根据美国法律，您的美国遗嘱仅管辖实际位于美国境内的资产。韩国、中国或其他地方的不动产、银行账户或商业权益受所在国法律约束，通常需要根据当地法律制定独立的法律文件——当地遗嘱或等效文件——才能合规转让。我们为您提供建议，指导如何构建美国遗嘱以承认这些国际资产，并在需要时与境外当地律师协调。对于在两个国家积累财富的移民家庭，这种协调正是全球有效计划与边境处失效计划之间的差距所在。" },
          { title: "为未成年子女指定监护人", body: "在印第安纳州，法院依据 IC § 29-3-5 确认监护权时采用\'子女最佳利益\'标准——但您遗嘱中的监护人指定对该决定具有实质性影响。对于移民家庭，这一决定通常涉及将国外可信赖的亲属指定为备用监护人，或明确规定偏向美国监护人的条件。我们帮助您全面考量语言、文化教育、宗教价值观、教育偏好和地理因素——为主要监护人和备用监护人分别起草具备印第安纳法院所需具体性的条款，以便在子女最需要的时刻，无论他们身在何处，都能落实您的意愿。" },
          { title: "与信托协调的遗产流入遗嘱", body: "遗产流入遗嘱是印第安纳州捕获您在生前未正式转入生前信托的资产的法律机制。根据印第安纳州法律，当您去世时，仅以您个人名义持有的财产——您忘记重新登记的银行账户、车辆，甚至意外继承的遗产——将由遗产流入遗嘱捕获，并按照信托条款进行分配。对于可能收到来自海外意外转账、购置新的美国资产或在信托注资过程中遗漏某些步骤的移民家庭，这一安全保障至关重要。协调完善的遗产流入遗嘱与生前信托共同构建无缝衔接的闭环遗产计划。" },
          { title: "数字资产和海外账户条款", body: "印第安纳州已采纳《统一受托人数字资产访问修订法》（IC § 32-39），赋予您的遗嘱执行人合法权限访问、管理和分配您的数字资产——但前提是您的遗产计划结构合理。若缺乏明确条款，执行人可能无法访问加密货币钱包、海外PayPal账户、在线业务，甚至存有重要金融记录的电子邮件账户。我们在接案时进行全面的数字资产清查，起草引用账户及访问凭证框架的可执行授权条款，确保您的执行人在需要时具备采取即时行动的法律资格。无论是国内还是境外的数字资产，都不应被遗漏。" },
          { title: "随生活情况变化定期审查", body: "印第安纳州法律（IC § 29-1-5-8）允许您在具有法律行为能力期间随时撤销或修改遗嘱——保持遗嘱现状与拥有遗嘱本身同等重要。对于移民家庭，变化是持续的：新子女出生、在本国置产、移民身份改变，或指定遗嘱执行人移居海外。任何此类事件都可能悄然破坏一份当初撰写时合理的计划。我们为现有客户提供结构化的遗嘱审查服务——通常每三年一次或在重大生活事件发生后进行——以确认您的遗嘱意愿始终准确、具有法律效力，并符合印第安纳州的现行要求。" },
        ],
      },
      {
        number: "02", title: "信托成立", calligraphy: "生前信托及更多",
        intro: "信托提供了单靠遗嘱无法实现的控制权。它允许您的遗产以私密方式转移，无需遗嘱认证，且跨越国界 — 对于有国际联系的移民家庭特别重要。",
        details: [
          { title: "绕过遗嘱认证的可撤销生前信托", body: "受 IC § 29-1 管辖的印第安纳州遗嘱认证程序是一项法院监督的公开程序，可能历时六个月至一年以上——在此期间，您的遗产清单、资产价值和家庭分配将成为公共记录的一部分。正确注资的可撤销生前信托可完全绕过这一程序。信托内资产无需法院批准即可私下转移给受益人，通常在身故后数周内完成。对于在韩国、中国或其他地方有受益人的移民家庭，这意义重大：海外家人无需经历他们从未接触过的美国法律程序即可获得遗产。关键词在于\'正确注资\'——我们不仅起草信托，还逐项指导您完成所有资产的重新登记，并确认注资完成。" },
          { title: "长期资产保护的不可撤销信托", body: "根据《印第安纳州信托法典》（IC § 30-4），不可撤销信托一旦设立，即将资产从您的应税遗产中移除，并阻止大多数未来债权人的接触——这是可撤销信托无法提供的保护。印第安纳州还根据 IC § 30-4-8 允许设立国内资产保护信托（DAPT），在特定条件下为您提供额外债权人保护，同时允许您保留作为受益人的权利。对于预期从海外获得大额遗产、保护数十年积累的业务或跨代规划的移民家庭而言，不可撤销信托可能是最有力的规划工具。我们在提出建议前会审慎评估哪种结构最符合您的具体目标。" },
          { title: "为受抚养家庭成员设立的特殊需求信托", body: "特殊需求信托（SNT）——有时称为补充需求信托——专为残障家庭成员设计，可在不剥夺其政府福利（如医疗补助和补充安全收入SSI）资格的情况下提供经济支持。根据印第安纳州和联邦法律，正确起草的SNT必须是对公共福利的补充而非替代——信托可以支付政府未涵盖的物品和服务，而不会引发福利资格的丧失。对于抚养残障子女或有特殊护理需求的年迈父母的移民家庭，这种信托结构通常是他们最重要的规划决策。我们严格遵守所有适用的印第安纳州和联邦要求起草第一方和第三方SNT，并对分配标准和受托人指示给予高度关注。" },
          { title: "多代财富传承规划", body: "印第安纳州是多代财富传承最为有利的州之一：不征收州级遗产税和继承税，并修订了禁止永久原则的适用——允许信托资产在信托中保存远比许多其他州更长的时间。我们设计包括根据当前联邦隔代跳跃转让豁免额度校准的隔代跳跃信托（GST）在内的信托结构，以最小化转让税敞口，同时高效地跨代传承资产。对于拥有不动产、紧密持股企业或大量投资组合的移民家庭，一个正确构建的信托可以将家族财富代代相传，同时保留您希望与资产一同传承的文化价值观和家庭治理原则。" },
          { title: "与国际遗产事宜的协调", body: "跨境遗产需要大多数美国律师难以提供的协调水平。包括韩国和中国在内的某些国家实行强制继承制度，可能推翻您的意愿分配，无论您的美国信托如何指示。此外，若您的配偶非美国公民，则无限婚姻扣除不适用——根据美国税法认可的特殊信托结构，适格境内信托（QDOT）可能对于递延向非公民配偶转让时的遗产税至关重要。我们提前识别这些跨境冲突点，将您的美国信托结构与国际法律考量相协调，并在复杂性要求时与境外遗产律师合作。" },
          { title: "持续的信托管理指导", body: "遗产规划中最常见且代价最高的错误之一，是精心起草了一份信托却未能完成注资。根据印第安纳州法律，可撤销生前信托仅控制以信托名义持有的资产——而非您计划某天放入其中的资产。常见失误包括：忘记重新登记新购置的房产、忽略更新401(k)账户和人寿保险的受益人指定，或将境外继承收益留在个人银行账户而非信托中。我们在设立信托时提供逐项资产的全面注资指南，实施后续注资审查，并随时解答管理问题，确保您的信托在生命的每个阶段都能准确实现您的初衷。" },
        ],
      },
      {
        number: "03", title: "婚前协议", calligraphy: "保护您的未来",
        intro: "婚前协议是保护资产、明确期望并规划未来的有力工具 — 尤其适合将跨境财产、商业利益或家庭义务带入婚姻的移民个人和家庭。",
        details: [
          { title: "婚前财产及储蓄的资产保护", body: "印第安纳州财产分割法令（IC § 31-15-7）形成了一种可反驳的推定：所有资产——包括带入婚姻的财产的增值部分——均须在离婚时进行公平分配。若无婚前协议，法院将决定何为\'公平\'，而结果可能与您的预期大相径庭。正确签署的婚前协议可对指定资产推翻这一推定。对于多年积累储蓄、在本国持有不动产或预期继承家族财产的移民而言，无论婚姻在何处、以何种方式结束，该协议都能确保这些资产受到明确且合法的保护。" },
          { title: "海外资产及国际持有的条款", body: "印第安纳州法院对本州婚姻解除适用印第安纳州法律，但位于海外的资产面临真实的执行挑战：即使是有效的印第安纳州判决，也可能需要在当事国另行提起法律诉讼才能对其境内财产强制执行。我们直接应对这一问题——以在印第安纳州可执行同时最大程度减少在相关外国司法管辖区复杂性的语言，起草针对海外不动产、境外银行账户、境外商业权益及预期继承资产的具体条款。对于在韩国或中国持有重大资产的客户，我们还将就本国平行文件是否能提供有意义的额外保护提出建议。" },
          { title: "商业权益及继承权保护", body: "根据印第安纳州法律，婚姻存续期间增值的商业权益，若婚姻努力——您的时间、精力或婚姻资金——对该增值有所贡献，则可能须部分分割。婚前协议可从一开始就将您的业务界定为独立财产、限定任何潜在的婚姻利益，并确立在协议受到挑战时的商定估值方法。对于拥有跨境商业结构——例如美国有限责任公司与韩国运营公司的组合——的移民家庭，这些条款必须同时涵盖国内和国际所有权两个维度。我们以印第安纳州法院所要求的精准度起草这些条款。" },
          { title: "债务分配及财务责任条款", body: "印第安纳州法院可能要求双方配偶共同承担婚姻存续期间产生的债务——即使该债务是一方配偶在另一方不知情的情况下独自承担的。婚前协议可直接应对这一风险：明确各方婚前债务的分配方式、确定婚姻期间产生的哪些财务义务以个人而非共同方式处理，以及阐明重大财务决策的做出方式。对于一方或双方配偶可能持有海外助学贷款、商业债务或对大家庭成员承担财务义务的移民家庭，这些条款既提供了法律保护，也为婚姻本身带来了有益的财务清晰度。" },
          { title: "反映文化和家庭价值观的定制条款", body: "《印第安纳州统一婚前协议法》（IC § 31-11-3）对婚前协议可涵盖的内容具有宽泛的许可性——使其成为尊重具有文化意义的财务安排的最灵活法律工具之一。我们的许多客户来自韩国或中国背景，在这些文化背景中，家族继承预期、赡养年迈父母的义务，或关于财产如何在家庭内流转的传统理解，都具有深刻意义。我们致力于将这些文化现实转化为清晰、可执行的合同语言——不仅满足法律最低要求，更确保协议真正体现对您的家庭最重要的价值观与承诺。" },
          { title: "法律精确且可执行的文件", body: "根据《印第安纳州统一婚前协议法》（IC § 31-11-3），若任何一方证明协议系被迫签署、源于欺诈或胁迫，或一方未获得对方财务状况的公平合理披露，则婚前协议可被撤销。印第安纳州法院曾拒绝执行在婚礼前不足10天签署，或一方当事人缺乏独立法律顾问的婚前协议。我们以可执行性为首要设计标准构建每一份协议：为双方提供全面且有据可查的财务披露清单、清晰的自愿签署声明、婚礼前至少30至60天的签署时间表，以及——在大多数情况下作为明确要求——每一方应聘请独立法律顾问的强烈建议。" },
        ],
        ctaExternalUrl: "https://marriagegreencard-junlawfirm.com",
        ctaExternalLabel: "基于婚姻的绿卡申请",
      },
    ],
  },
  process: {
    calligraphy: "共同的旅程", title1: "我们", title2: "如何合作",
    steps: [
      { step: "I", title: "咨询", desc: "我们以您的语言开始对话 — 关于您的家庭、您的心愿以及您特有的跨境考量。" },
      { step: "II", title: "量身定制策略", desc: "我们设计清晰的计划 — 无论是遗嘱、生前信托还是两者兼有 — 考虑您的文化价值观和遗产的复杂性。" },
      { step: "III", title: "专业文件起草", desc: "每份文件都以法律精确性起草，反映您的真实意图，并在最重要的时刻跨越国界保持有效。" },
      { step: "IV", title: "持久的平静心情", desc: "您的遗产计划得到执行并安全保存。您的家庭得到保护。您的遗产以您的声音定义。" },
    ],
    finalCalligraphy: "今天开始",
    finalTitle1: "您家庭的未来",
    finalTitle2: "值得拥有计划",
    finalDesc: "您跨越国界建立了您的生活。我们帮助您为下一代保护它 — 以您的语言，深深尊重您的文化和家庭独特的旅程。",
    finalCta1: "预约咨询",
    finalCta2: "拨打 (317) 701-2768",
  },
  footer: {
    desc: "为移民家庭提供的遗产规划 — 以文化敏感性、法律精确性和对您所走过旅程的真诚关怀打造。",
    langAvailable: "可用语言",
    langs: ["한국어 상담 가능", "English Services Available", "提供中文服務"],
    copyright: "全弘民律师事务所。保留所有权利。· 服务移民社区",
    privacy: "隐私政策", terms: "服务条款", disclaimer: "免责声明",
    servicesTitle: "服务", companyTitle: "公司", resourcesTitle: "资源",
    willDrafting: "遗嘱起草", trustFormation: "信托成立", prenuptialAgreement: "婚前协议",
    aboutUs: "关于我们", services: "服务", faqs: "常见问题", contact: "联系",
    freeConsultation: "预约咨询",
  },
  aboutPage: {
    heroCalligraphy: "关于我们",
    heroH1Line1: "一位理解",
    heroH1Line2: "您旅程的律师",
    heroDesc: "我们建立这家事务所是为了服务从其他地方移民来的家庭 — 那些在两个世界中穿梭、面对两套法律现实、深切希望保护自己所建立的一切的家庭。",
    attyCalligraphy: "认识您的律师",
    attyTitle: "律师",
    attyExp: "印第安纳州 & 伊利诺伊州持牌 · IU McKinney法学院 J.D.",
    attyQuote: "\"从首尔企业界到印第安纳法律界的历程，让我亲身理解了同时在两个世界中生活的意义。这段经历塑造了我为移民家庭和企业主制定的每一份计划。\"",
    attyBio1: "我帮助移民家庭和小企业主创建遗嘱、信托和婚前协议，反映他们跨越国界、文化和世代的独特生活。在执业之前，我曾在首尔SK集团工作，这让我对跨越国际界限生活和工作所面临的挑战有了切身体会。",
    attyBio2: "我持有印第安纳州和伊利诺伊州的律师执照，拥有印第安纳大学McKinney法学院的J.D.学位和Maurer法学院的M.C.L.学位。我服务的每一位客户都获得我的个人关注、完全透明和真诚关怀制定的计划。",
    credentials: [
      { label: "J.D.", value: "Indiana University McKinney School of Law" },
      { label: "M.C.L.", value: "Indiana University Maurer School of Law" },
      { label: "执照州", value: "印第安纳州 · 伊利诺伊州" },
      { label: "专业领域", value: "遗嘱起草 · 信托成立 · 婚前协议" },
      { label: "语言", value: "English · 한국어 · 中文" },
      { label: "过往经历", value: "SK集团，首尔，韩国" },
    ],
    storyCalligraphy: "我们的使命",
    storyTitle1: "我们也是移民 —",
    storyTitle2: "我们了解您走过的路",
    storyP1: "许多移民家庭花了几十年在这个国家建立生活 — 通常同时维持与本国的联系、资产和责任。标准的遗产规划往往忽视这种复杂性。我们不会。",
    storyP2: "这家事务所的成立是为了填补这一空白。我们将严格的法律专业知识与真正的文化敏感性和多语言服务相结合 — 让每位客户都能自由沟通、完全理解、充分信任。",
    storyP3: "我们专注于遗嘱起草、信托成立和婚前协议 — 做好这三个学科，能为移民家庭提供他们努力工作应得的持久安全。",
    atGlanceCalligraphy: "一览",
    atGlance: [
      { label: "专业领域", value: "遗嘱起草 · 信托成立 · 婚前协议" },
      { label: "持牌州", value: "印第安纳州 & 伊利诺伊州" },
      { label: "学历", value: "IU McKinney (J.D.) · IU Maurer (M.C.L.)" },
      { label: "服务语言", value: "English · 한국어 · 中文" },
      { label: "初次咨询", value: "以您的语言" },
      { label: "过往经历", value: "SK集团，首尔，韩国" },
    ],
    atGlanceQuote: "\"您的家人跨越大洋建立了某些东西。我们确保它得以延续。\"",
    valuesCalligraphy: "我们的立场",
    valuesTitle1: "我们对",
    valuesTitle2: "移民家庭的承诺",
    values: [
      { icon: "ri-translate-2", title: "多语言", desc: "我们用您的语言沟通 — 英语、韩语和中文 — 确保在最重要的时刻不会因翻译而丢失信息。" },
      { icon: "ri-global-line", title: "跨境意识", desc: "我们了解跨越多个国家的资产、家庭关系和法律考量的复杂性。" },
      { icon: "ri-heart-3-line", title: "文化敏感", desc: "您的文化传统和家庭结构在我们起草的每份文件中都得到尊重和体现。" },
      { icon: "ri-shield-check-line", title: "法律精确", desc: "遗嘱起草和信托成立的深厚专业知识 — 每份文件都严密、个性化且经久耐用。" },
    ],
    ctaCalligraphy: "准备好开始了吗？",
    ctaTitle1: "让我们一起",
    ctaTitle2: "规划您的遗产",
    ctaDesc: "以您的语言，牢记您的故事。咨询是保护您的家人辛苦建立的一切的第一步。",
    ctaBtn: "开始对话",
  },
  servicesPage: {
    heroCalligraphy: "我们的工作",
    heroH1Line1: "遗嘱、信托与",
    heroH1Line2: "婚前协议。",
    heroDesc: "我们专门从事遗嘱起草、信托成立和婚前协议 — 对移民家庭在跨越国界和文化规划未来时所面临的挑战有深刻理解。提供英语、韩语和中文服务。",
    inquireCta: "咨询此服务",
    includedCalligraphy: "包含内容",
    services: [
      {
        number: "01", title: "遗嘱起草", calligraphy: "最终遗嘱与遗言",
        intro: "遗嘱是您心愿最直接的表达 — 对于移民家庭，它更具分量。两个国家的资产，跨越大洲的大家庭，超越国界的监护权问题。我们全面处理。",
        desc: "我们以细心的态度对待每份遗嘱，从您的语言开始，彻底了解您的家庭、资产和个人意图。",
        features: ["为个人和夫妻定制的简单和复杂遗嘱", "针对在本国持有资产的条款", "为未成年子女指定监护人", "与生前信托协调的遗嘱", "数字资产条款和海外账户指示", "医疗指示和委托书"],
      },
      {
        number: "02", title: "信托成立", calligraphy: "生前信托及更多",
        intro: "信托提供了单靠遗嘱无法实现的控制权。它允许您的遗产以私密方式转移，无需遗嘱认证，且跨越国界 — 保护您的家庭免受延迟、公开披露和意外复杂性的影响。",
        desc: "我们构建反映您精确意图的信托，无论是保护幸存配偶、为有特殊需求的子女提供支持，还是管理国际遗产。",
        features: ["用于避免遗嘱认证的可撤销生前信托", "资产保护和税务规划的不可撤销信托", "为受抚养家庭成员设立的特殊需求信托", "多代财富传承规划", "与国际遗产事宜的协调", "持续的信托管理和修订支持"],
      },
      {
        number: "03", title: "婚前协议", calligraphy: "保护您的未来",
        intro: "婚前协议是保护资产、明确期望并规划未来的有力工具 — 尤其适合将跨境财产、商业利益或家庭义务带入婚姻的移民个人和家庭。",
        desc: "我们起草清晰、可执行的婚前协议，既体现法律精确性，又尊重塑造您家庭故事的文化价值观。",
        features: ["婚前财产及储蓄的资产保护", "海外资产及国际持有的条款", "商业权益及继承权保护", "债务分配及财务责任条款", "反映文化和家庭价值观的定制条款", "法律精确且可执行的文件"],
      },
    ],
    ctaCalligraphy: "不确定从哪里开始？",
    ctaTitle1: "我们的咨询",
    ctaTitle2: "是完美的第一步",
    ctaDesc: "我们将评估您的情况，帮助您了解遗嘱、信托或两者兼有 — 以您的语言，考虑您家庭的独特背景 — 哪种方式是正确的。",
    ctaBtn: "预约咨询",
  },
  faqsPage: {
    heroCalligraphy: "我们有答案",
    heroH1Line1: "像您这样的家庭",
    heroH1Line2: "经常问的问题",
    heroDesc: "移民家庭和小企业主最常问我们的真实问题的诚实答案 — 关于遗嘱、信托、跨境资产和规划未来。",
    questionsLabel: "个问题",
    ctaCalligraphy: "还有问题吗？",
    ctaTitle: "您的情况是独特的",
    ctaDesc: "每个移民家庭的故事都不同。全律师很乐意在无义务咨询中 — 以您的语言 — 回答您的具体问题。",
    ctaBtn: "预约咨询",
    categories: [
      {
        category: "移民家庭", icon: "ri-global-line",
        items: [
          { q: "即使我不是美国公民或永久居民，我也需要遗嘱吗？", a: "是的 — 绝对需要。您的移民身份不影响您在美国创建遗嘱或信托的权利。没有计划，印第安纳州的无遗嘱继承法将决定您的资产如何分配，这些规则可能完全不反映您家庭的实际情况。" },
          { q: "我在另一个国家有资产。美国遗嘱可以覆盖它们吗？", a: "美国遗嘱通常管辖位于美国的资产。对于在海外持有的资产，您可能需要根据该国法律制定单独的遗嘱或法律文件。我们可以帮助您协调美国遗产计划与国际考量。" },
          { q: "我的家人仍然住在本国。我可以将他们列为受益人吗？", a: "是的。无论居住在哪里或公民身份如何，您都可以在遗嘱或信托中将任何人命名为受益人。我们将确保使用适当的法律语言，使跨境分配尽可能顺畅。" },
          { q: "如果我持有签证或移民身份待定时去世，我的遗产会怎样？", a: "无论您去世时的签证或移民身份如何，您的遗产计划都是有效且可执行的。但是，如果您的配偶不是美国公民，无限婚姻扣除可能不适用。合格境内信托(QDOT)在这种情况下可能是重要的规划工具。" },
          { q: "如果我的英语有限，可以用韩语或中文合作吗？", a: "当然可以。我们提供英语、韩语和中文的完整法律服务。您不应该在不完全舒适的语言中做出重要的法律决定。从初次咨询到签署文件，我们确保您理解遗产计划的每个字。" },
        ],
      },
      {
        category: "遗嘱起草", icon: "ri-file-text-line",
        items: [
          { q: "如果我在印第安纳州没有遗嘱就去世，会发生什么？", a: "印第安纳州的无遗嘱继承法将决定您的遗产如何分配。对于有复杂家庭关系的移民家庭，没有遗嘱去世可能尤其有问题。遗嘱确保您的声音被听到。" },
          { q: "我可以为住在另一个国家的未成年子女指定监护人吗？", a: "您可以在遗嘱中表达对监护人的偏好，包括住在海外的人。但是，印第安纳州法院对监护权有最终权力，将考虑孩子的最佳利益。我们建议同时指定主要监护人和替代监护人。" },
          { q: "如何在美国遗嘱中处理多个国家的资产？", a: "您的美国遗嘱可以包含承认您国际资产并表达您意图的条款。出于执行目的，外国资产通常由该国法律管辖。我们帮助您建立与国际资产协调的美国计划。" },
          { q: "我应该多久更新一次遗嘱？", a: "我们建议每3-5年或在重大生活事件后审查您的遗嘱。我们为现有客户提供简单、实惠的更新服务。" },
        ],
      },
      {
        category: "信托成立", icon: "ri-shield-check-line",
        items: [
          { q: "为什么生前信托对移民特别有用？", a: "可撤销生前信托避免了遗嘱认证 — 一个缓慢且昂贵的公开法庭程序。对于有国际联系的家庭，这尤其有价值。住在海外的受益人不需要处理漫长的美国遗嘱认证程序。" },
          { q: "信托可以为不是美国公民的子女保护资产吗？", a: "是的。信托可以持有并向任何受益人分配资产，无论其公民身份或居住国。您可以指定分配条件和时间表，以确保您的资产按照您的心愿使用。" },
          { q: "如果我回国，我的信托会怎样？", a: "如果在美国正确设立和资助，美国可撤销生前信托通常在您移居海外后仍然有效。但是，您的搬迁可能影响信托的税务处理。我们强烈建议在任何国际移动之前审查您的遗产计划。" },
          { q: "可撤销和不可撤销信托有什么区别？", a: "可撤销信托可以随时更改或撤销 — 您保持完全控制。不可撤销信托一旦建立通常无法更改。作为交换，它提供强大的保护：保护资产免受债权人侵害并减少您的应税遗产。" },
        ],
      },
      {
        category: "小企业主", icon: "ri-store-2-line",
        items: [
          { q: "如果我没有遗产计划就去世，我的小企业会怎样？", a: "没有计划，您的商业权益将成为遗嘱认证遗产的一部分。这可能意味着数月的法庭程序，期间您的企业可能无法有效运营或被迫出售。适当的遗产计划确保您的企业按照您的条件继续或结束。" },
          { q: "我可以将我的商业权益放入信托吗？", a: "是的，对许多小企业主来说这是非常可取的。将您的商业权益放入可撤销生前信托，可以让它在不经过遗嘱认证的情况下转移给您选择的继任者。" },
          { q: "我是企业的唯一所有者。我需要企业继承计划吗？", a: "个人遗产计划和继承计划都很重要，它们应该协同工作。您的个人遗产计划解决谁继承您的商业权益。继承计划进一步确定谁将经营企业以及管理和所有权过渡如何运作。" },
          { q: "作为移民小企业主，有什么独特的遗产规划注意事项？", a: "几个重要的事项。如果您的配偶不是美国公民，无限婚姻扣除可能不适用，使信托规划更加紧迫。如果您在本国有商业伙伴或投资者，跨境所有权和继承规则需要仔细关注。这些正是我们专门处理的情况。" },
        ],
      },
      {
        category: "婚前协议", icon: "ri-hearts-line",
        items: [
          { q: "作为移民，我需要婚前协议吗？", a: "对于带着婚前资产、海外财产或家庭继承期望进入婚姻的移民来说，婚前协议尤其有价值。没有协议，这些资产可能以您意想不到的方式依据美国法律被分割。婚前协议让您对自己辛苦建立的一切保有控制权。" },
          { q: "婚前协议可以涵盖我在另一个国家持有的资产吗？", a: "是的。精心起草的婚前协议可以包含涉及海外不动产、外国银行账户、境外商业利益以及预期从本国家庭继承遗产的条款。我们确保在国际背景下语言尽可能具有可执行性。" },
          { q: "婚前协议在印第安纳州有法律效力吗？", a: "是的，婚前协议根据《统一婚前协议法》在印第安纳州具有可执行性，前提是自愿签订、双方充分披露财务状况且无不合理条款。我们起草的协议经得起法律审查。" },
          { q: "文化传统或家庭习俗可以在婚前协议中体现吗？", a: "当然可以。我们的许多客户来自家庭继承、代代相传的财产或特定家庭财务义务扮演重要角色的文化背景。我们努力在印第安纳州法律允许的范围内尊重这些传统。" },
          { q: "婚礼前多早应该开始准备？", a: "我们建议在婚礼日期至少2至3个月前开始这一流程。太接近婚礼日期签署的婚前协议可能因胁迫而受到质疑。提前开始让双方有时间在没有压力的情况下审查、协商和签署。" },
          { q: "我的未婚夫/妻需要单独的律师吗？", a: "强烈建议——在某些情况下为了协议的可执行性也是必要的——每一方都应有独立的法律顾问审查协议。如有需要，我们可以为您的配偶推荐咨询律师，确保流程公平，协议经久耐用。" },
        ],
      },
    ],
  },
  contactPage: {
    heroCalligraphy: "开始您的旅程",
    heroH1Line1: "我们在这里",
    heroH1Line2: "为您的家庭服务",
    heroDesc: "您的咨询以您的语言进行，深深尊重您的独特背景。请告诉我们您的情况，我们将为您指引前进的道路。",
    badges: [
      { icon: "ri-award-line", text: "初次咨询" },
      { icon: "ri-translate-2", text: "English · 한국어 · 中文" },
      { icon: "ri-shield-check-line", text: "移民和小企业专属" },
      { icon: "ri-time-line", text: "1个工作日内回复" },
    ],
    infoTitle: "联系信息",
    infoAddress: "办公室地址",
    infoPhone: "电话",
    infoEmail: "电子邮件",
    infoHours: "办公时间",
    hoursValue: "周一至周五：上午9时 – 下午6时\n周六：上午10时 – 下午2时",
    whoCalligraphy: "服务对象",
    whoTitle: "专为以下人群提供指导：",
    whoItems: [
      "移民家庭（任何签证或公民身份）",
      "规划未来的非公民配偶",
      "在两个国家拥有资产的家庭",
      "没有继承计划的小企业主",
      "韩语和中文客户",
      "用第二语言规划遗产的任何人",
    ],
    urgentCalligraphy: "紧急事项",
    urgentTitle: "可提供紧急咨询",
    urgentDesc: "如果您的情况需要及时处理——疾病、即将出行或紧急家庭需求——请直接致电我们讨论优先安排。",
    formCalligraphy: "咨询",
    formTitle: "预约咨询",
    formSubtitle: "请分享您的情况，我们将为咨询做好充分准备。咨询需收费。所有信息均严格保密。",
    successCalligraphy: "已收到您的信息！",
    successMsg: "全律师将亲自审阅您的咨询，并在一个工作日内以您偏好的语言与您联系。",
    fieldName: "全名",
    fieldEmail: "电子邮件地址",
    fieldPhone: "电话号码",
    fieldPrefLang: "首选语言",
    fieldImmStatus: "移民身份",
    fieldSmallBiz: "您是小企业主吗？",
    fieldService: "所需服务",
    fieldOverseas: "是否在另一个国家有资产？",
    fieldCountry: "原籍国 / 本国",
    fieldMessage: "描述您的情况",
    messagePlaceholder: "请简要描述您的家庭情况、资产以及您希望实现的目标。没有错误的答案——任何背景信息都有帮助...",
    selectPlaceholder: "请选择",
    immStatusOptions: [
      "美国公民",
      "永久居民（绿卡）",
      "签证持有者（H-1B、L-1等）",
      "待定身份 / 其他",
      "不愿透露",
    ],
    serviceOptions: [
      "遗嘱起草",
      "信托成立",
      "遗嘱和信托均需",
      "婚前协议",
      "企业继承规划",
      "尚不确定",
    ],
    yesOpt: "是",
    noOpt: "否",
    notSureOpt: "不确定",
    errorMsg: "出现错误。请重试或直接致电我们。",
    sending: "发送中...",
    submitBtn: "提交咨询申请",
    formDisclaimer: "咨询需收费。您的信息严格保密。",
  },
};

export default zh;
